import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      keywords: 'AI招聘,人才招聘,智能面试,AI面试,招聘系统,AI招聘网站,AI求职,人才库,岗位推荐,招聘趋势,高薪职位,找工作',
      description: '智聘AI招聘平台'
    }
  },
  { path: '/login', name: 'Login', component: () => import('../views/login/Login.vue') },//登录
  { path: '/login_wx', name: 'Login_wx', component: () => import('../views/login/Login_wx.vue') },//微信登录
  { path: '/login_phone', name: 'Login_phone', component: () => import('../views/login/Login_phone.vue') },//手机登录
  { path: '/template', name: 'Template', component: () => import('../views/template/Template.vue') },//简历模板
  { path: '/template/:id', name: 'Tempdeil', component: () => import('../views/template/Temdeil.vue') },//简历模板详情
  { path: '/diag', name: 'Diag', component: () => import('../views/diag/Diag.vue') },//简历诊断


  { path: '/personal', name: 'Personal', component: () => import('../views/personal/Personal.vue'), },//个人中心/基本信息
  { path: '/headimg', name: 'Headimg', component: () => import('../views/personal/Headimg.vue') },//个人中心/设置头像
  { path: '/phone', name: 'Phone', component: () => import('../views/personal/Phone.vue') },//个人中心/手机绑定
  { path: '/pwd', name: 'Pwd', component: () => import('../views/personal/Pwd.vue') },//个人中心/修改密码
  { path: '/order', name: 'Order', component: () => import('../views/personal/Order.vue') },//个人中心/我的订单
  { path: '/orderdeil/:id', name: 'Orderdeil', component: () => import('../views/personal/Orderdeil.vue') },//个人中心/订单详情
  { path: '/resume', name: 'Resume', component: () => import('../views/personal/Resume.vue') },//个人中心/简历诊断
  { path: '/myresume', name: 'Myresume', component: () => import('../views/personal/Myresume.vue') },//个人中心/简历诊断
  { path: '/register', name: 'register', component: () => import('../views/register/index.vue') },//个人中心/注册
  { path: '/forget', name: 'forget', component: () => import('../views/login/forget.vue') },//忘记密码


  { path: '/post', name: 'post', component: () => import('../views/news/news copy.vue') },//新闻
  { path: '/new', name: 'new', component: () => import('../views/news/news.vue') },//新闻/
  { path: '/news/:id.html', name: 'news', component: () => import('../views/news/newsdeil.vue') },//新闻/新闻详情
  { path: '/list2.html', name: 'list2', component: () => import('../views/news/list1/index.vue') },//新闻/面试辅导
  { path: '/list3.html', name: 'list3', component: () => import('../views/news/list2/index.vue') },//新闻/简历优化
  { path: '/list4.html', name: 'list4', component: () => import('../views/news/list3/index.vue') },//新闻/工作推荐
  { path: '/postdeil/:id.html', name: 'postdeil', component: () => import('../views/news/list4/index.vue') },//新闻/全部文章

  //AI面试
  {
    path: '/allTabs/interview',
    meta: {
      keywords: '简历解析, 人才匹配, 智能岗位推荐, 视频面试, 智能筛选简历, AI人岗精准匹配, AI招聘推荐引擎, AI面试语音分析, AI模拟面试辅导, 智能人才库管理系统, AI招聘效率工具, AI招聘效率工具',
      description: '智聘AI招聘平台'
    },
    name: 'interview', component: () => import('../views/allTabs/interview/index.vue')
  },
  // 人才管理页面
  {
    path: '/allTabs/talent-management',
    meta: {
      keywords: '简历解析, 人才匹配, 智能岗位推荐, 视频面试, 智能筛选简历, AI人岗精准匹配, AI招聘推荐引擎, AI面试语音分析, AI模拟面试辅导, 智能人才库管理系统, AI招聘效率工具, AI招聘效率工具',
      description: '智聘AI招聘平台'
    },
    name: 'talent', component: () => import('../views/allTabs/talent-management/index.vue')
  },
  // 就业舱
  {
    path: '/allTabs/employment',
    meta: {
      keywords: '如何提升招聘效率, 招聘流程优化方法, 缩短招聘周期的技巧, AI面试的优势, AI智能筛选简历, AI人才匹配算法, 如何提升候选人体验, AI招聘的公平性, AI招聘的公平性, AI招聘的公平性, AI招聘ROI分析, AI招聘ROI分析, AI招聘成功案例, 最佳招聘软件推荐, 最佳招聘软件推荐',
      description: '智聘AI招聘平台'
    },
    name: 'employment', component: () => import('../views/allTabs/employment/index.vue')
  },
  // 产品中心
  //案列展示
  {
    path: '/allTabs/example',
    meta: {
      keywords: '半导体行业招聘, 金融招聘, 制造业招聘, 技术岗位招聘, 销售招聘, 人工智能行业招聘, IT技术招聘, 智驾岗招聘, 机器人岗招聘, 半导体招聘, 新能源与智能制造招聘, 生物医药招聘, 集成电路工程师招聘',
      description: '智聘AI招聘平台'
    },
    name: 'example', component: () => import('../views/allTabs/example/index.vue')
  },
  //关于我们
  { path: '/allTabs/about-us', 
     meta: {
      keywords: '简历解析, 人才匹配, 智能岗位推荐, 视频面试, 智能筛选简历, AI人岗精准匹配, AI招聘推荐引擎, AI面试语音分析, AI模拟面试辅导, 智能人才库管理系统, AI招聘效率工具, AI招聘效率工具',
      description: '智聘AI招聘平台'
    },
    
    name: 'about-us', component: () => import('../views/allTabs/about-us/index.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }

})

export default router
